import axios from 'axios';
import Cookies from 'js-cookie';
import { cookieDecryption, expireTime } from '../utils';
import SessionExpiredPopup from '../components/Popup/SessionExpiredPopup';
import store from '../rematch';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});
let isErrorOccurred = false;
axiosClient.defaults.timeout = 600000;

axiosClient.interceptors.response.use(
  function (response) {
    if (isErrorOccurred) {
      return Promise.reject({ message: 'Request failed with status code 401' });
    }
    if (response.data?.code === 401) {
      Cookies.remove('userDetails', {
        path: '/',
        expires: expireTime(),
      });
      isErrorOccurred = true;
      window.location.reload();
    }
    return response;
  },
  function (error) {
    if (isErrorOccurred) {
      return Promise.reject({ message: 'Request failed with status code 401' });
    }
    const res = error.response;
    if (!res) {
      console.error('Looks like there was a problem (no HTTP response).', error?.message || error);
      return Promise.reject(error);
    }
    const { dispatch, getState } = store;
    console.error('Looks like there was a problem. Status Code:' + res.status);
    // Only 401 means "re-authenticate". 403 is often authorization / feature / infra (e.g. blocked analytics)
    // and must not clear the session UX — it caused false "session expired" after successful login.
    if (res.status === 401) {
      const state = getState();
      isErrorOccurred = true;
      if (state.messagesModel.isErrorOccured) {
      } else {
        dispatch.messagesModel.setMsgState({
          name: 'isErrorOccured',
          data: true,
        });
        dispatch.dialogModel.showDialog({
          component: () => <SessionExpiredPopup />,
          className: 'alert_popup_height',
        });
      }
    }
    return Promise.reject(error);
  }
);

axiosClient.interceptors.request.use(function (config) {
  const auth = cookieDecryption('userDetails');
  const token = auth?.token;
  config.headers['x-auth-token'] = token || '';
  return config;
});

export default axiosClient;
